//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'YouTubeOrImage',
  props: {
    youTubeVideoId: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: () => ({
        url: '',
        alt: ''
      })
    }
  },
  computed: {
    showImage() {
      if (this.image) {
        if (this.image.url) {
          return true;
        }
        return false;
      }
      return false;
    }
  },
  methods: {
    // Bynder images can be videos as well, so support those with isVideo and getExtension
    isVideo(url) {
      // mp4, webm, and ogg are the video formats currently supported by HTML
      return ['mp4', 'webm', 'ogg'].some((format) =>
        (url || '').endsWith(`.${format}`)
      );
    },
    getExtension(url) {
      return url.split('.').pop();
    }
  }
};
